export const WORKSPACES = [
  {
    id: "coetic-x-workspace",
    name: "Coetic X",
    type: "Business organization",
    email: "hello@coetic-x.com",
    currency: "EUR",
    logo: "/coetic-x-mark.svg",
    documentLanguage: "en",
    regionalFormat: "XK",
    documentDateStyle: "medium",
    documentNumberStyle: "symbol-prefix",
  },
];

export const LOGIN_ACCOUNTS = {
  "hello@coetic-x.com": "coetic-x-workspace",
};

export const USER_PROFILE = {
  id: "sample-admin",
  workspaceId: "coetic-x-workspace",
  name: "Alex Morgan",
  email: "hello@coetic-x.com",
  role: "Owner",
  initials: "AM",
  publicMode: false,
  status: "Active",
  businessIds: ["*"],
  accountingPermissions: ["*"],
  interfaceLanguage: "en",
};

export const TEAM_MEMBERS = [
  {
    id: "sample-admin",
    workspaceId: "coetic-x-workspace",
    name: "Alex Morgan",
    email: "hello@coetic-x.com",
    role: "Owner",
    jobTitle: "Founder",
    managerId: "",
    initials: "AM",
    businessIds: ["*"],
    accountingPermissions: ["*"],
    status: "Active",
  },
  {
    id: "elira-krasniqi",
    workspaceId: "coetic-x-workspace",
    name: "Elira Krasniqi",
    email: "elira@coetic-x.example",
    role: "Manager",
    jobTitle: "Accounting manager",
    managerId: "",
    initials: "EK",
    businessIds: ["coetic-x"],
    accountingPermissions: ["intake", "purchases", "banking", "quickbooks", "declarations", "ledger"],
    status: "Active",
  },
  {
    id: "mira-berisha",
    workspaceId: "coetic-x-workspace",
    name: "Mira Berisha",
    email: "mira@coetic-x.example",
    role: "Employee",
    jobTitle: "Accountant",
    managerId: "elira-krasniqi",
    initials: "MB",
    businessIds: ["coetic-x"],
    accountingPermissions: ["intake", "banking"],
    status: "Invited",
  },
];

export const WORK_REMINDERS = [
  {
    id: "sample-reminder-bank-statement",
    workspaceId: "coetic-x-workspace",
    businessId: "coetic-x",
    kind: "missing_document",
    title: "Collect the August bank statement",
    note: "Confirm that all pages and the closing balance are included.",
    status: "open",
    priority: "high",
    assigneeUserId: "sample-admin",
    dueAt: "2026-08-28T09:00:00.000Z",
    relatedEntityType: "business",
    relatedEntityId: "coetic-x",
    createdAt: "2026-08-25T08:00:00.000Z",
    updatedAt: "2026-08-25T08:00:00.000Z",
  },
  {
    id: "sample-reminder-overdue-invoice",
    workspaceId: "coetic-x-workspace",
    businessId: "coetic-x",
    kind: "follow_up",
    title: "Follow up on invoice 2026/003",
    note: "Confirm the payment date with Northstar Labs and record the outcome.",
    status: "open",
    priority: "urgent",
    assigneeUserId: "sample-admin",
    dueAt: "2026-08-26T10:00:00.000Z",
    relatedEntityType: "invoice",
    relatedEntityId: "cx-2026-003",
    createdAt: "2026-08-24T09:30:00.000Z",
    updatedAt: "2026-08-25T14:10:00.000Z",
  },
  {
    id: "sample-reminder-month-close",
    workspaceId: "coetic-x-workspace",
    businessId: "coetic-x",
    kind: "deadline",
    title: "Prepare the August close",
    note: "Reconcile paid invoices and collect any missing expense documents.",
    status: "open",
    priority: "normal",
    assigneeUserId: "elira-krasniqi",
    dueAt: "2026-08-31T13:00:00.000Z",
    relatedEntityType: "business",
    relatedEntityId: "coetic-x",
    createdAt: "2026-08-22T07:45:00.000Z",
    updatedAt: "2026-08-25T12:20:00.000Z",
  },
];

export const WORK_TASKS = [
  {
    id: "sample-task-review-documents",
    workspaceId: "coetic-x-workspace",
    businessId: "coetic-x",
    title: "Review received source documents",
    description: "Check the accounting period and mark incomplete evidence for follow-up.",
    status: "in_progress",
    priority: "normal",
    assigneeUserId: "sample-admin",
    dueAt: "2026-08-29T11:00:00.000Z",
    sourceReminderId: "sample-reminder-bank-statement",
    createdAt: "2026-08-25T08:10:00.000Z",
    updatedAt: "2026-08-25T08:20:00.000Z",
  },
  {
    id: "sample-task-prepare-invoices",
    workspaceId: "coetic-x-workspace",
    businessId: "coetic-x",
    title: "Prepare the September invoice batch",
    description: "Reuse recurring services, confirm dates, and review client-specific tax defaults.",
    status: "todo",
    priority: "high",
    assigneeUserId: "sample-admin",
    dueAt: "2026-08-28T14:00:00.000Z",
    createdAt: "2026-08-24T10:15:00.000Z",
    updatedAt: "2026-08-25T09:05:00.000Z",
  },
  {
    id: "sample-task-payment-match",
    workspaceId: "coetic-x-workspace",
    businessId: "coetic-x",
    title: "Review the Blue Harbor payment match",
    description: "Confirm the bank reference and attach the payment evidence to the invoice record.",
    status: "review",
    priority: "normal",
    assigneeUserId: "elira-krasniqi",
    dueAt: "2026-08-27T11:30:00.000Z",
    createdAt: "2026-08-23T08:40:00.000Z",
    updatedAt: "2026-08-25T15:10:00.000Z",
  },
  {
    id: "sample-task-tax-treatment",
    workspaceId: "coetic-x-workspace",
    businessId: "coetic-x",
    title: "Confirm cross-border tax treatment",
    description: "Verify the client evidence before finalizing the Northstar invoice note.",
    status: "blocked",
    priority: "high",
    assigneeUserId: "elira-krasniqi",
    dueAt: "2026-08-27T15:00:00.000Z",
    createdAt: "2026-08-22T12:00:00.000Z",
    updatedAt: "2026-08-25T11:25:00.000Z",
  },
  {
    id: "sample-task-archive-july",
    workspaceId: "coetic-x-workspace",
    businessId: "coetic-x",
    title: "Archive the July bank statement",
    description: "The closing balance and supporting pages have been checked.",
    status: "done",
    priority: "low",
    assigneeUserId: "sample-admin",
    dueAt: "2026-08-22T09:00:00.000Z",
    createdAt: "2026-08-20T08:30:00.000Z",
    updatedAt: "2026-08-22T09:20:00.000Z",
  },
];

export const WORK_ITEM_ACTIVITIES = [
  { id: "sample-work-activity-3", workspaceId: "coetic-x-workspace", businessId: "coetic-x", taskId: "sample-task-review-documents", reminderId: "", actorId: "sample-admin", actor: "Alex Morgan", action: "status_changed", note: "", safeChanges: { status: "in_progress" }, occurredAt: "2026-08-25T08:20:00.000Z" },
  { id: "sample-work-activity-2", workspaceId: "coetic-x-workspace", businessId: "coetic-x", taskId: "sample-task-review-documents", reminderId: "", actorId: "sample-admin", actor: "Alex Morgan", action: "created", note: "", safeChanges: { status: "todo" }, occurredAt: "2026-08-25T08:10:00.000Z" },
  { id: "sample-work-activity-1", workspaceId: "coetic-x-workspace", businessId: "coetic-x", taskId: "", reminderId: "sample-reminder-bank-statement", actorId: "sample-admin", actor: "Alex Morgan", action: "created", note: "", safeChanges: { status: "open" }, occurredAt: "2026-08-25T08:00:00.000Z" },
];

export const BUSINESSES = [
  {
    id: "coetic-x",
    workspaceId: "coetic-x-workspace",
    name: "Coetic X",
    legalName: "Coetic X LLC",
    email: "hello@coetic-x.com",
    location: "Prishtina, Kosovo",
    countryCode: "XK",
    vatStatus: "registered",
    vatNumber: "",
    initials: "CX",
    logo: "/coetic-x-mark.svg",
    tone: "orange",
    contacts: [
      { id: "coetic-x-contact-primary", name: "Alex Morgan", role: "Owner", email: "hello@coetic-x.com", phone: "+383 00 000 001", preferredChannel: "WhatsApp", language: "English", primary: true, primaryFor: ["accounting", "document-request", "owner"], status: "Active" },
    ],
    engagement: {
      pricingEnabled: false,
      feeAmount: "",
      feeCurrency: "EUR",
      feeCadence: "Monthly",
      pricingNote: "",
      internalNotes: "",
      relationshipStatus: "Active",
    },
  },
];

const KOSOVO_STANDARD_VAT = [{ id: "vat-standard", label: "VAT", rate: "18", treatment: "added" }];
const KOSOVO_STANDARD_PROFILE = {
  useAsDefault: true,
  confirmed: true,
  source: "jurisdiction-suggestion",
  ruleId: "xk-domestic-standard",
  lines: KOSOVO_STANDARD_VAT,
  invoiceNote: "",
  explanation: "Kosovo standard VAT confirmed for this recurring client relationship.",
};
const CROSS_BORDER_SERVICE_PROFILE = {
  useAsDefault: true,
  confirmed: true,
  source: "jurisdiction-suggestion",
  ruleId: "xk-cross-border-b2b-services",
  lines: [],
  invoiceNote: "VAT not charged - place of supply outside Kosovo under Article 20. Customer tax status verified.",
  explanation: "Cross-border B2B service treatment confirmed for this recurring client relationship.",
};

export const INVOICES = [
  { id: "cx-2026-004", invoiceNumber: "2026/004", workspaceId: "coetic-x-workspace", issuerId: "coetic-x", clientId: "coetic-x-workspace-client-1", client: "Acme Studio LLC", work: "Product strategy sprint", issued: "Aug 23", issuedDate: "2026-08-23", due: "Sep 06", dueDate: "2026-09-06", amount: 12980, currency: "EUR", status: "Sent", paymentTerms: "Net 14", items: [{ id: "cx-2026-004-line-1", description: "Product strategy sprint", detail: "Approved billable work", quantity: "1", rate: "11000" }], taxLines: KOSOVO_STANDARD_VAT, taxReviewed: true, notes: "Thank you for the partnership.", footerNotes: "Payment by bank transfer." },
  { id: "cx-2026-003", invoiceNumber: "2026/003", workspaceId: "coetic-x-workspace", issuerId: "coetic-x", clientId: "coetic-x-workspace-client-2", client: "Northstar Labs Ltd", work: "Design system", issued: "Jul 18", issuedDate: "2026-07-18", due: "Aug 17", dueDate: "2026-08-17", amount: 9800, currency: "EUR", status: "Overdue", paymentTerms: "Net 30", items: [{ id: "cx-2026-003-line-1", description: "Design system", detail: "Approved billable work", quantity: "1", rate: "9800" }], taxLines: [], taxNote: CROSS_BORDER_SERVICE_PROFILE.invoiceNote, taxReviewed: true, footerNotes: "Payment by bank transfer." },
  { id: "cx-2026-002", invoiceNumber: "2026/002", workspaceId: "coetic-x-workspace", issuerId: "coetic-x", clientId: "coetic-x-workspace-client-3", client: "Blue Harbor GmbH", work: "Platform audit", issued: "Aug 12", issuedDate: "2026-08-12", due: "Aug 26", dueDate: "2026-08-26", paidOn: "2026-08-12", amount: 16000, currency: "EUR", status: "Paid", paymentTerms: "Net 14", items: [{ id: "cx-2026-002-line-1", description: "Platform audit", detail: "Approved billable work", quantity: "1", rate: "16000" }], taxLines: [], taxNote: CROSS_BORDER_SERVICE_PROFILE.invoiceNote, taxReviewed: true },
  { id: "cx-2026-001", invoiceNumber: "2026/001", workspaceId: "coetic-x-workspace", issuerId: "coetic-x", clientId: "coetic-x-workspace-client-4", client: "Juniper & Co", work: "Monthly retainer", issued: "Aug 01", issuedDate: "2026-08-01", due: "Aug 01", dueDate: "2026-08-01", paidOn: "2026-08-01", amount: 9000, currency: "EUR", status: "Paid", paymentTerms: "On receipt", items: [{ id: "cx-2026-001-line-1", description: "Monthly retainer", detail: "Approved billable work", quantity: "1", rate: "9000" }], taxLines: [], taxNote: CROSS_BORDER_SERVICE_PROFILE.invoiceNote, taxReviewed: true },
  { id: "cx-2026-005", invoiceNumber: "2026/005", workspaceId: "coetic-x-workspace", issuerId: "coetic-x", clientId: "coetic-x-workspace-client-1", client: "Acme Studio LLC", work: "Implementation support", issued: "Aug 24", issuedDate: "2026-08-24", due: "Sep 07", dueDate: "2026-09-07", amount: 7080, currency: "EUR", status: "Draft", paymentTerms: "Net 14", items: [{ id: "cx-2026-005-line-1", description: "Implementation support", detail: "Approved billable work", quantity: "1", rate: "6000" }], taxLines: KOSOVO_STANDARD_VAT, taxReviewed: true },
];

// Prior periods may be imported as aggregate history before their individual
// invoice records are migrated into Invoice Studio.
export const SAMPLE_COLLECTION_HISTORY = [
  { month: "2026-01", businessId: "coetic-x", total: 18500, source: "Imported accounting summary" },
  { month: "2026-02", businessId: "coetic-x", total: 21800, source: "Imported accounting summary" },
  { month: "2026-03", businessId: "coetic-x", total: 28400, source: "Imported accounting summary" },
  { month: "2026-04", businessId: "coetic-x", total: 24600, source: "Imported accounting summary" },
  { month: "2026-05", businessId: "coetic-x", total: 31900, source: "Imported accounting summary" },
  { month: "2026-06", businessId: "coetic-x", total: 27200, source: "Imported accounting summary" },
  { month: "2026-07", businessId: "coetic-x", total: 23500, source: "Imported accounting summary" },
];

export const SAMPLE_WORKSPACE_VERSION = 7;

const mergeSampleRecords = (existing, canonical) => {
  const current = Array.isArray(existing) ? existing : [];
  const knownIds = new Set(current.map((record) => record.id));
  return [
    ...current,
    ...canonical.filter((record) => !knownIds.has(record.id)).map((record) => ({ ...record })),
  ];
};

export const upgradeSampleWorkspace = (data) => {
  if (!data?.sampleWorkspace) return data;
  const currentVersion = Number(data.sampleWorkspaceVersion || 0);
  if (currentVersion >= SAMPLE_WORKSPACE_VERSION) return data;

  let nextData = data;
  if (currentVersion < 2) {
    const canonicalInvoices = new Map(INVOICES.map((invoice) => [invoice.id, invoice]));
    const invoices = (data.invoices || []).map((invoice) => {
      const legacyAdjustmentId = `${invoice.id}-rounding`;
      if (!(invoice.adjustments || []).some((adjustment) => adjustment.id === legacyAdjustmentId)) return invoice;
      const canonical = canonicalInvoices.get(invoice.id);
      if (!canonical) return invoice;
      return {
        ...invoice,
        amount: canonical.amount,
        items: canonical.items.map((item) => ({ ...item })),
        adjustments: invoice.adjustments.filter((adjustment) => adjustment.id !== legacyAdjustmentId),
      };
    });
    nextData = { ...nextData, invoices };
  }

  if (currentVersion < 5) {
    const canonicalInvoices = new Map(INVOICES.map((invoice) => [invoice.id, invoice]));
    const invoices = (nextData.invoices || []).map((invoice) => {
      const canonical = canonicalInvoices.get(invoice.id);
      if (!canonical) return invoice;
      return {
        ...invoice,
        amount: canonical.amount,
        items: canonical.items.map((item) => ({ ...item })),
      };
    });
    nextData = { ...nextData, invoices };
  }

  if (currentVersion < 6) {
    const replaceOwner = (id) => id === "arber-shabani" ? USER_PROFILE.id : id;
    const ownerMember = { ...TEAM_MEMBERS[0] };
    const teamMembers = [
      ownerMember,
      ...(nextData.teamMembers || []).filter((member) => !["arber-shabani", USER_PROFILE.id].includes(member.id)),
    ];
    const workTasks = (nextData.workTasks || []).map((task) => task.assigneeUserId === "arber-shabani"
      ? { ...task, assigneeUserId: replaceOwner(task.assigneeUserId) }
      : task);
    const workReminders = (nextData.workReminders || []).map((reminder) => reminder.assigneeUserId === "arber-shabani"
      ? { ...reminder, assigneeUserId: replaceOwner(reminder.assigneeUserId) }
      : reminder);
    const workItemActivities = (nextData.workItemActivities || []).map((activity) => activity.actorId === "arber-shabani" || activity.actor === "Arber Shabani"
      ? { ...activity, actorId: USER_PROFILE.id, actor: USER_PROFILE.name }
      : activity);
    const activityLog = (nextData.activityLog || []).map((activity) => activity.actor === "Arber Shabani"
      ? { ...activity, actor: USER_PROFILE.name }
      : activity);
    const businesses = (nextData.businesses || []).map((business) => ({
      ...business,
      contacts: (business.contacts || []).map((contact) => contact.name === "Arber Shabani"
        ? { ...contact, name: USER_PROFILE.name, language: "English" }
        : contact),
    }));
    nextData = {
      ...nextData,
      profile: { ...USER_PROFILE, publicMode: Boolean(nextData.profile?.publicMode) },
      teamMembers,
      workTasks,
      workReminders,
      workItemActivities,
      activityLog,
      businesses,
    };
  }

  if (currentVersion < 7) {
    const canonicalClients = new Map(CLIENTS.map((client) => [client.id, client]));
    const clients = (nextData.clients || []).map((client) => {
      const canonical = canonicalClients.get(client.id);
      if (!canonical) return client;
      return { ...client, issuerId: canonical.issuerId, sharedAcrossIssuers: false };
    });
    nextData = { ...nextData, clients };
  }

  const collectionHistory = currentVersion < 5
    ? SAMPLE_COLLECTION_HISTORY.map((period) => ({ ...period }))
    : Array.isArray(nextData.collectionHistory) && nextData.collectionHistory.length
    ? nextData.collectionHistory
    : SAMPLE_COLLECTION_HISTORY.map((period) => ({ ...period }));
  const workReminders = currentVersion < 4
    ? mergeSampleRecords(nextData.workReminders, WORK_REMINDERS)
    : nextData.workReminders;
  const workTasks = currentVersion < 4
    ? mergeSampleRecords(nextData.workTasks, WORK_TASKS)
    : nextData.workTasks;
  return { ...nextData, collectionHistory, workReminders, workTasks, sampleWorkspaceVersion: SAMPLE_WORKSPACE_VERSION };
};

const CLIENT_LIBRARY = [
  { name: "Acme Studio LLC", contact: "Jordan Lee", email: "billing@acme-studio.example", phone: "+383 00 000 011", contacts: [{ id: "acme-contact-primary", name: "Jordan Lee", role: "Finance", email: "billing@acme-studio.example", phone: "+383 00 000 011", preferredChannel: "WhatsApp", language: "English", primary: true, primaryFor: ["invoice-delivery", "receivables"], status: "Active" }], initials: "AS", terms: "Net 14", currency: "EUR", outstanding: "EUR 20,060", lifetime: "EUR 92,400", tone: "orange", issuerId: "coetic-x", sharedAcrossIssuers: false, countryCode: "XK", customerType: "business", taxNumber: "", serviceCategory: "professional-services", taxProfilesByIssuer: { "coetic-x": KOSOVO_STANDARD_PROFILE } },
  { name: "Northstar Labs Ltd", contact: "Casey Morgan", email: "accounts@northstar-labs.example", phone: "+44 0000 000 012", contacts: [{ id: "northstar-contact-primary", name: "Casey Morgan", role: "Accounts payable", email: "accounts@northstar-labs.example", phone: "+44 0000 000 012", preferredChannel: "WhatsApp", language: "English", primary: true }], initials: "NL", terms: "Net 30", currency: "EUR", outstanding: "EUR 9,800", lifetime: "EUR 68,200", tone: "charcoal", issuerId: "coetic-x", sharedAcrossIssuers: false, countryCode: "GB", customerType: "business", taxNumber: "GB-EXAMPLE", serviceCategory: "professional-services", taxProfilesByIssuer: { "coetic-x": CROSS_BORDER_SERVICE_PROFILE } },
  { name: "Blue Harbor GmbH", contact: "Morgan Fischer", email: "finance@blue-harbor.example", contacts: [{ id: "blue-harbor-contact-primary", name: "Morgan Fischer", role: "Finance", email: "finance@blue-harbor.example", phone: "", preferredChannel: "Email", language: "English", primary: true }], initials: "BH", terms: "Net 14", currency: "EUR", outstanding: "EUR 0", lifetime: "EUR 54,000", tone: "sage", issuerId: "coetic-x", sharedAcrossIssuers: false, countryCode: "DE", customerType: "business", taxNumber: "DE-EXAMPLE", serviceCategory: "professional-services", taxProfilesByIssuer: { "coetic-x": CROSS_BORDER_SERVICE_PROFILE } },
  { name: "Juniper & Co", contact: "Alex Rivera", email: "hello@juniper-co.example", contacts: [{ id: "juniper-contact-primary", name: "Alex Rivera", role: "Owner", email: "hello@juniper-co.example", phone: "", preferredChannel: "Email", language: "English", primary: true }], initials: "JC", terms: "On receipt", currency: "EUR", outstanding: "EUR 0", lifetime: "EUR 41,500", tone: "sand", issuerId: "coetic-x", sharedAcrossIssuers: false, countryCode: "US", customerType: "business", taxNumber: "US-EXAMPLE", serviceCategory: "professional-services", taxProfilesByIssuer: { "coetic-x": CROSS_BORDER_SERVICE_PROFILE } },
];

export const CLIENTS = WORKSPACES.flatMap((workspace) => CLIENT_LIBRARY.map((client, index) => ({
  ...client,
  id: `${workspace.id}-client-${index + 1}`,
  workspaceId: workspace.id,
})));

const SERVICE_LIBRARY = [
  { name: "Product strategy sprint", detail: "Workshop, research, and roadmap", rate: "12000", currency: "EUR", unit: "fixed", used: 12 },
  { name: "Product design", detail: "Interface and interaction design", rate: "180", currency: "EUR", unit: "hour", used: 28 },
  { name: "Engineering support", detail: "Implementation and review", rate: "210", currency: "EUR", unit: "hour", used: 19 },
  { name: "Monthly product retainer", detail: "Reserved product and engineering time", rate: "10000", currency: "EUR", unit: "month", used: 9 },
];

export const SERVICES = WORKSPACES.flatMap((workspace) => SERVICE_LIBRARY.map((service, index) => ({
  ...service,
  id: `${workspace.id}-service-${index + 1}`,
  workspaceId: workspace.id,
})));

export const REPORT_BARS = [42, 58, 47, 76, 64, 92, 81, 100];

export const SETTINGS_ITEMS = [
  ["Organization profile", "Account identity, communication, and logo"],
  ["Issuing businesses", "Legal entities that can issue invoices"],
  ["Invoice defaults", "Currency, due dates, numbering, and standard notes"],
  ["Data and backups", "Local storage, portable exports, and recovery"],
  ["Language and locale", "Dashboard and document language, dates, and number formatting"],
];

export const ACTIVITY_LOG = [
  { id: "activity-5", at: "2026-08-24T09:18:00.000Z", actor: "Alex Morgan", action: "Invoice updated", entityType: "invoice", entityId: "cx-2026-005", detail: "Saved draft 2026/005" },
  { id: "activity-4", at: "2026-08-23T14:40:00.000Z", actor: "Alex Morgan", action: "Invoice sent", entityType: "invoice", entityId: "cx-2026-004", detail: "Sent 2026/004 to Acme Studio LLC" },
  { id: "activity-3", at: "2026-08-18T10:05:00.000Z", actor: "Alex Morgan", action: "Invoice updated", entityType: "invoice", entityId: "cx-2026-003", detail: "Updated due date for 2026/003" },
  { id: "activity-2", at: "2026-08-12T16:32:00.000Z", actor: "Alex Morgan", action: "Payment recorded", entityType: "invoice", entityId: "cx-2026-002", detail: "Marked 2026/002 as paid" },
  { id: "activity-1", at: "2026-08-01T08:54:00.000Z", actor: "Alex Morgan", action: "Invoice created", entityType: "invoice", entityId: "cx-2026-001", detail: "Created 2026/001 for Juniper & Co" },
];
